// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedCompany: null
}

const companies = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_COMPANIES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_COMPANIES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_COMPANY':
      return { ...state, selectedCompany: action.selectedCompany }
    case 'ADD_COMPANY':
      return { ...state }
    case 'DELETE_COMPANY':
      return { ...state }
    default:
      return { ...state }
  }
}
export default companies
